export default {
  allowAttachments: false,
  allowButton: false,
  allowHeading: false,
  allowSocial: false,
  allowSubheading: false,
  allowUploads: false
};